<template>
  <div>
    <page-title
      isback
      pageName="批量导入"/>
    <div class='comm-container'>
      <div class='comm-page-container pd30'>
        <el-steps class='import-step' :active="active" finish-status="success">
          <el-step title="上传文件"></el-step>
          <el-step title="执行导入"></el-step>
          <el-step title="导入完成"></el-step>
        </el-steps>
        <div v-if='active === 1'>
          <el-row class='step1-box mt20'>
            <el-col :span='3' class='text-center  step-box-left'>
              <i class='iconfont iconshangchuan2'></i>
            </el-col>
            <el-col :span='21' class='step-box-right'>
              <div class='step-box-title'>填写导入货品的信息</div>
              <div class='step-box-tip'>请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除，批量导入不会影响现有货品数据</div>
              <el-button type="text" @click='downloadBtn'>下载模板</el-button>
            </el-col>
          </el-row>
          <el-row class='step1-box mt20'>
            <el-col :span='3' class='text-center step-box-left'>
              <i class='iconfont iconxiazai3'></i>
            </el-col>
            <el-col :span='21' class='step-box-right'>
              <div class='step-box-title'>上传填好的货品信息表</div>
              <div class='step-box-tip'>文件后缀名必须为xls 或xlsx （即Excel格式），文件大小不得大于10M</div>
              <el-upload
                class="upload-demo"
                :headers="{'authorization':token}"
                :action="baseUrl + 'goods/import'"
                name="file"
                :before-remove="beforeRemove"
                :before-upload="beforeAvatarUpload"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :on-success="handleSuccess"
                :file-list="fileList">
                <el-button type="text">点击上传</el-button>
              </el-upload>
            </el-col>
          </el-row>
        </div>
        <div v-if='active === 2'>
          <el-row class='step2-box mt20'>
            <el-col :span='3' class='text-center  step-box-left'>
              <i class='iconfont iconshangchuanchenggong1 primary-color'></i>
            </el-col>
            <el-col :span='21' class='step-box-right'>
              <div class='step-box-title'>本次可导入的货品数量</div>
              <div class='step-box-title mt10 primary-color'>{{successList.length}}条</div>
            </el-col>
          </el-row>
          <el-row class='step2-box mt20'>
            <el-col :span='3' class='text-center  step-box-left'>
              <i class='iconfont iconshangchuanshibai3 danger-color'></i>
            </el-col>
            <el-col :span='21' class='step-box-right'>
              <div class='step-box-title'>本次不可导入的货品数量</div>
              <div class='step-box-title mt10 font-weight  danger-color'>{{failList.length}}条</div>
            </el-col>
          </el-row>
          <div class='error-title mt30' v-if='failList.length > 0'>不可导入的货品列表</div>
          <el-table border :data="failList" class='mt10' v-if='failList.length > 0'>
            <el-table-column
              label='行数'
              type="index"/>
              <el-table-column
                label="证书"
                prop='goodsCertificate'
                sortable>
              </el-table-column>
              <el-table-column
                sortable
                prop='goodsCertificateNum'
                label="证书号"/>
              <el-table-column
                sortable
                prop='goodsShape'
                label="形状"/>
              <el-table-column
                sortable
                prop='goodsNum'
                label="数量"/>
              <el-table-column
                sortable
                prop='goodsWeight'
                label="重量"/>
              <el-table-column
                sortable
                prop='goodsColour'
                label="颜色"/>
              <el-table-column
                sortable
                width='50px'
                prop='pricingMethod'
                label="计价方式" />
              <el-table-column
                sortable
                prop='goodsCleanliness'
                label="净度"/>
              <el-table-column
                sortable
                prop='goodsCutwork'
                label="切工"/>
              <el-table-column
                sortable
                prop='goodsSpecifications'
                label="规格"/>
              <el-table-column
                sortable
                prop='goodsSymmetric'
                label="对称"/>
              <el-table-column
                sortable
                prop='goodsPolishing'
                label="抛光"/>
              <el-table-column
                sortable
                prop='goodsTone'
                label="色调"/>
              <el-table-column
                sortable
                prop='goodsFluorescence'
                label="荧光"/>
              <el-table-column
                sortable
                prop='goodsPrice'
                label="价格"/>
              <el-table-column
                sortable
                prop='isUppershelf'
                label="上架"/>
              <el-table-column
                prop='errorMsg'
                label="错误提示">
                <template slot-scope="scope">
                  <div style='color:red'>{{scope.row.errorMsg}}</div>
                </template>
              </el-table-column>
          </el-table>
        </div>
        <div v-if='active === 3' class='step-success text-center'>
          <i class='iconfont iconchenggong primary-color'></i>
          <div class='step-success-title'>批量导入完成</div>
          <div class='step-success-tips'>成功导入货品数量:{{successNum}}条</div>
        </div>
        <div></div>
        <div class='text-center mt20'>
          <el-button @click="next" v-if='active !== 3' :disabled='!isNext' type='primary'>下一步</el-button>
          <el-button @click="backImport" v-if='active === 2'>返回重新上传</el-button>
          <el-button type='primary' @click='successBtn' v-if='active === 3'>完成</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AddGoods',
  data () {
    return{
      token: localStorage.getItem('user_token'),
      baseUrl: this.$api.baseUrl,
      active: 1,
      tableData:[],
      failNum:null,
      successNum:null,
      saveNum:null,
      fileList:[],
      isNext:false,
      successList:[],
      failList:[]
    }
  },
  methods: {
    next() {
      if(this.active === 1){
        if (this.active++ > 2) this.active = 0;
      }else if(this.active === 2){
        this.$ajax({
          method:'post',
          url:'goods/addGoods',
          data:this.successList
        }).then(res => {
          if(res.data.code > 0){
            this.successNum = res.data.data.success ? res.data.data.success.length : 0
            if (this.active++ > 2) this.active = 0;
          }else{
            this.$message.warning(res.data.desc)
          }
        })
      }
    },
    downloadBtn(){
      window.location.href = this.baseUrl+ 'upload/download'
    },
    backImport(){
      this.active = 1
      this.isNext = false
      this.successList = []
      this.failList = []
      this.fileList = []
    },
    beforeRemove (file, fileList) {
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`)
    },
    handleChange(){

    },
    beforeAvatarUpload (file) {
      let isExecl = file.name.substr(-4) === '.xls' || file.name.substr(-4) === 'xlsx'
      const isLt2M = file.size / 1024 / 1024 < 10;
      if(!isExecl){
        this.$message.error('上传文件只能是 execl 文件!');
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      return isExecl && isLt2M;
    },
    handleSuccess (res, file) {
      if (res.code > 0) {
        this.isNext = true
        if (res.data) {
          if(res.data.success && res.data.success.length > 0){
            res.data.success.forEach(item => {
              item.goodsTypeId = this.$route.query.tabId
            })
          }
          this.successList = res.data.success || []
          this.failList = res.data.fail || []
        }
      } else {
        this.fileList = []
        this.$message.warning(res.desc)
      }
    },
    successBtn(){
      this.$router.push({
        path:'/goods'
      })
    }
  }
}
</script>
<style scoped>
.step1-box,.step2-box{
  color:#666;
  border:1px solid #ededed;
}
.step-box-right{
  padding:15px 30px 8px;
  border-left:1px solid #ededed;
}
.step-box-title{
  font-weight: bold;
}
.step-box-tip{
  margin:12px 0 4px;
  font-size:14px;
}
.step-box-left .iconfont{
  font-size: 46px;
  padding: 29px 0 0;
  display: inline-block;
}
.step2-box .step-box-left .iconfont{
}
.step2-box .step-box-right{
  padding: 33px 30px;
}
.error-title{
  color:#666;
  font-size:14px;
}
.step-success .iconfont{
  font-size: 68px;
  margin: 50px 0 20px;
  display: block;
  color: #0079fe;
}
.step-success .step-success-title{
  font-weight: bold;
  font-size: 28px;
  margin: 20px 0 16px;
}
.step-success .step-success-tips{
  color:#666;
  margin-bottom: 60px;
}
.import-step >>> .el-step__head.is-success{
  color:#0079fe;
  border-color:#0079fe;
}
.import-step >>> .el-step__title.is-success{
  color:#0079fe;
}
</style>
